import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useSkillVaultEnabled } from '../hooks';
import { ActivityListPage } from './ActivityListPage';
import { ActivityDetailPage } from './ActivityDetailPage';
import { SkillManagementPage } from './SkillManagementPage';
import { ProjectManagementPage } from './ProjectManagementPage';

export const SpassuCodePage = () => {
  const location = useLocation();
  const params = useParams();
  const skillVaultEnabled = useSkillVaultEnabled();

  // FlatRoutes consumes the full path, so we detect /skills via location.
  // Feature flag off (spassuCode.features.skillVault): deep link falls back
  // to the activity list instead of rendering the Skill Vault page.
  if (location.pathname.endsWith('/skills')) {
    if (!skillVaultEnabled) {
      return <Navigate to="/spassu-code" replace />;
    }
    return <SkillManagementPage />;
  }

  // Project management: /spassu-code/project-members
  if (location.pathname.endsWith('/project-members')) {
    return <ProjectManagementPage />;
  }

  // If activityId param exists (from FlatRoutes /:activityId match), show detail
  const activityId = params.activityId ?? params['*'];
  if (activityId && activityId !== 'skills') {
    return <ActivityDetailPage />;
  }

  // Default: activity list
  return <ActivityListPage />;
};
